import React from 'react';
import { Link } from 'react-router-dom';
import { Customer, CustomerLocation } from '../types';

export function customerOriginLabel(origin?: string | null): string {
  if (origin === 'lead') return 'From Data';
  if (origin === 'tender') return 'From Tender';
  return 'Direct';
}

export function locationConversionCaption(loc: CustomerLocation): string {
  const so = (loc.sales_officer_name || '').trim();
  const assigned = so ? ` · Assigned to ${so}` : '';
  const by = loc.converted_by_name
    ? so
      ? ` . Converted by ${loc.converted_by_name}`
      : ` · Converted by ${loc.converted_by_name}`
    : '';
  if (loc.converted_from_tender_id) {
    return `From Tender #${loc.converted_from_tender_id}${assigned}${by}`;
  }
  if (loc.converted_from_lead_id) {
    return `From Data #${loc.converted_from_lead_id}${assigned}${by}`;
  }
  if (assigned || by) {
    return `Direct${assigned}${by}`;
  }
  return 'Direct';
}

export const CustomerOriginBadge: React.FC<{ customer: Customer; compact?: boolean }> = ({
  customer,
  compact = false,
}) => {
  const origin = customer.origin || (customer.converted_from_lead_id
    ? 'lead'
    : customer.converted_from_tender_id
      ? 'tender'
      : 'direct');
  const label = customerOriginLabel(origin);
  const className = compact
    ? 'inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-700'
    : 'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800';

  if (origin === 'tender' && customer.converted_from_tender_id) {
    return (
      <span className={className}>
        {label}{' '}
        <Link to={`/tenders/${customer.converted_from_tender_id}`} className="text-yellow-700 hover:underline ml-0.5">
          #{customer.converted_from_tender_id}
        </Link>
      </span>
    );
  }
  if (origin === 'lead' && customer.converted_from_lead_id) {
    return (
      <span className={className}>
        {label}{' '}
        <Link to={`/leads/${customer.converted_from_lead_id}`} className="text-yellow-700 hover:underline ml-0.5">
          #{customer.converted_from_lead_id}
        </Link>
      </span>
    );
  }
  return <span className={className}>{label}</span>;
};
